<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('ex.redemption')}}</div>
		</div>
		<div class="head_box">
			<div class="title">
				{{$t('ex.Balance')}}
			</div>
			<div class="yue_box">
				<div class="box">
					{{info.money?info.money:0}} IDR
				</div>
				<div class="mx"></div>
				<div class="box">
					{{info.usdt_money?info.usdt_money:0}} USDT
				</div>
			</div>
			<div class="text">
				<span>0{{$t('ex.Transaction')}}</span>
				<span class="mx_2">|</span>
				<span>{{$t('ex.exchange')}}</span>
				<span class="mx_2">|</span>
				<span>{{$t('ex.Simple')}}</span>
			</div>
		</div>
        <div class="content_wrap">
			<div class="box">
				<div class="t">
					{{$t('ex.Consume')}}
				</div>
				<div class="c">
					<div class="cent">
						<input v-if="status" type="number" v-model="usdtNum" placeholder="0" @input="changeUsdt">
						<input v-if="!status" type="number" v-model="rpNum" placeholder="0" @input="changeRp">
					</div>
					<div class="ico">
						{{status?'USDT':'IDR'}}
					</div>
				</div>
			</div>
			<a class="icons" @click="status = !status">
				<img src="../../assets/images/hh.png" alt="">
			</a>
			<div class="box">
				<div class="t">
					{{$t('ex.Obtain')}}
				</div>
				<div class="c">
					<div class="cent">
						<input v-if="!status" type="number" disabled v-model="usdtNum" placeholder="0">
						<input v-if="status" type="number" disabled v-model="rpNum" placeholder="0">
					</div>
					<div class="ico">
						{{status?'IDR':'USDT'}}
					</div>
				</div>
			</div>
			<div class="texts">
				{{$t('ex.rate')}}: 1{{status?'USDT':'IDR'}} ≈ {{!status?data.id_to_usd_rate:data.usd_to_id_rate}}{{status?'IDR':'USDT'}}
			</div>
			<div class="btn">
				<a @click.stop="confirmFun"> 
					{{$t('ex.Exchange')}}
				</a>
			</div>
			<!-- <div class="icon_logo">
				<div>
					<img src="../../assets/images/1.png" alt="">
					<span>0交易费</span>
				</div>
				<div>
					<img src="../../assets/images/2.png" alt="">
					<span>无滑点</span>
				</div>
				<div>
					<img src="../../assets/images/3.png" alt="">
					<span>更多币对组合</span>
				</div>
			</div> -->
        </div>
		<div v-show="setPwd" class="real_name_mask">
			<div class="real_box">
				<div class="tit" />
				<p class="tips" style="font-size: 16px; ">
					{{ $t('cash.setPwdFirst') }}
				</p>
				<div class="basic_btn" @click="setIniPwd">
					{{ $t('cash.setNow') }}
				</div>
			</div>
		</div>
		<van-popup v-model="write_psd" closeable close-icon="close" round position="bottom">
			<div class="psw_box">
				<van-password-input :value="psd_val" :mask="true" :focused="showKeyboard"
					@focus="showKeyboard = true" />
				<div class="keybord_box">
					<div class="keybord">
						<a class="key_item" v-for="i in 9" @click.stop="onInput(i)">
							<span class="key_inner">{{ i }}</span>
						</a>
						<a class="key_item no_bg">
							<span class="key_inner"></span>
						</a>
						<a class="key_item" @click="onInput(0)">
							<span class="key_inner">0</span>
						</a>
						<a class="key_item no_bg x" @click="onDelete">
							<span class="key_inner">×</span>
						</a>
					</div>
				</div>
				<div style="width:100%;height: 50px;background: #F0F0F0;"></div>
			</div>
		</van-popup>
	</div>

</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from 'vue';
import { Popup,
	PasswordInput,
	NumberKeyboard, Dialog, Toast } from 'vant';
Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(Dialog);
export default {
	name: "ex",
	data() {
		return {
			data: {},
			info:{},
			form: {
				password: '',
			},
			submitType:0,
			psd_val: '',
			write_psd: false,
			showKeyboard: true,
			setPwd:false,
			usdtNum:'',
			rpNum:'',
			status: false,
			number: "",
			isSig:1,
			lang:localStorage.getItem('lang')
		};
	},
	created() {
		this.$parent.footer('ex', false);
		Fetch("/index/webconfig").then((r) => {
			this.data = r.data
		});
		Fetch('/user/my_bank').then((r) => {
			this.setPwd = r.data.intPwd;
		});
		Fetch("/user/info").then((r) => {
			this.info = r.data
		});
	},
	mounted() {
		
	},
	methods: {
		submit() {
			this.psd_val = "";
			Fetch('/user/trade_convert', {
				idr: this.rpNum,
				usdt:this.usdtNum,
				type:this.status?1:0,
				passwd: this.form.password
			}).then((r) => {
				if (r.code == 1) {
					Fetch("/user/info").then((rs) => {
						this.usdtNum = ''
						this.rpNum = ''
						this.info = rs.data
						Toast(r.info)
					});
				}else{
					Toast(r.msg)
				}
			});
		},
		setIniPwdSubmit() {
			this.psd_val = "";
			Fetch('/user/setIniPwd', {
				password: this.form.password
			}).then((r) => {
				if (r.code == 1) {
					this.$toast(r.info)
					setTimeout(() => {
						this.setPwd = false;
					}, 500);
				}else{
					this.$toast(r.msg)
				}
			});
		},
		onInput(key) {
			this.psd_val = (this.psd_val + key).slice(0, 6);
			if (this.psd_val.length == 6) {
				this.write_psd = false;
				this.form.password = this.psd_val;
				if(this.submitType === 1){
					this.submit()
				}else {
					this.setIniPwdSubmit();
				}
			}
		},
		onDelete() {
			this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
		},
		subAll() {
			this.form.money = this.data.money;
		},
		setIniPwd() {
			this.write_psd = true;
		},
		changeUsdt(){
			this.rpNum = (this.usdtNum * Number(this.data.usd_to_id_rate)).toFixed(2)
		},
		changeRp(){
			this.usdtNum = (this.rpNum * Number(this.data.id_to_usd_rate)).toFixed(2)
		},
		confirmFun() {
			if(Number(this.usdtNum) > this.info.usdt_money && this.status){
				this.$toast(this.$t('ex.balances'))
				return
			}
			if(Number(this.rpNum) > this.info.money  && !this.status){
				this.$toast(this.$t('ex.balances'))
				return
			}
			if(this.status && this.usdtNum == '' ||!this.status && this.rpNum == 0){
				this.$toast(this.$t('ex.account'))
				return
			}
			if(this.setPwd){
				this.submitType == 0
			}else {
				this.write_psd = true;
				this.submitType = 1
			}
		}
	}
};
</script>

<style lang="less" scoped>
.basic_wrap {
	width: 100%;
	min-height: 200px;
	background: url(../../assets/images/bg.jpg) no-repeat center top / 100%;
}
.head_box {
	width: 100%;
	height: 160px;
	padding: 50px 10px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.title {
		font-size: 24px;
		font-weight: bold;
		color: #efefef;
		letter-spacing: 2px;
		text-indent: 2px;
		margin-bottom: 20px;
	}
	.yue_box {
		width: 85%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
		.box {
			width: 45%;
			text-align: center;
			font-size: 16px;
			font-weight: bold;
			color: #bdc303;
			white-space: nowrap;
		}
		.mx {
			height: 20px;
			width: 10px;
		}
	}
	.text {
		color: #cfcfcf;
		font-size: 14px;
		display: flex;
		justify-content: center;
		.mx_2 {
			margin: 0 10px;
		}
	}
}
.content_wrap {
	width: 100%;
	margin-top: -10px;
	border-radius: 20px 20px 0px 0px;
	height: fit-content;
	min-height: 100px;
	background: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 50px;
	padding-bottom: 50px;
	.texts2 {
		width: 80%;
		margin: 0 auto 10px auto;
		text-align: left;
		color:#333;
		font-size: 14px;
		display: flex;
		.left {
			margin-right: 5px;
		}
		.b {
			font-weight: bold;
			color: #333;
		}
	}
	.box {
		width: 85%;
		height: 100px;
		background: #eee;
		border-radius: 20px;
		padding: 20px;
		.t {
			font-size: 14px;
			margin-bottom: 10px;
		}
		.c  {
			width: 100%;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.cent {
				width: 80%;
				height: 40px;
				line-height: 40px;
				font-size: 16px;
				color: #333;
			}
			.ico {
				font-size: 16px;
				color: #333;
				font-weight: bold !important;
			}
		}
	}
	.icons {
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px;
		border-radius: 50%;
		border: 1px solid #999;
		margin: 20px auto;
		img {
			display: block;
			width: 100%;
			height: 100%;
			box-sizing: border-box;
		}
	}
	.texts {
		margin: 20px auto 40px auto;
		color: #999;
	}
	.btn {
		width: 85%;
		height: 40px;
		border-radius: 30px;
		background: #0E0E0E;
		color: #fff;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
		letter-spacing: 1px;
		text-indent: 1px;
		a {
			display: block;
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.icon_logo {
		width: 85%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 50px;
		div {
			width: 33%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			img {
				display: block;
				width: 30px;
				height: 30px;
			}
			span {
				font-size: 12px;
				margin-top: 10px;
			}
		}
	}
}
.keybord_box {
	height: 250px;
	background-color: #F0F0F0;
	margin-top: 35px;
	padding: 24px 12px 0 12px;
	margin: 0 auto;
	display: flex;
	justify-content: center;

	.keybord {
		width: 361px;
		margin: 24px auto 0 atuo;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		text-align: center;

		.key_item {
			display: block;
			width: 115px;
			height: 44px;
			line-height: 44px;
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 6px;
			background: rgba(255, 255, 255, 1);
			border-radius: 3px;
			cursor: pointer;

			&.no_bg {
				background: none;
			}

			&.x {
				color: #757880;
				font-weight: bold;
			}
		}
	}
}
</style>
